<template>
  <div>
    <v-data-table :headers="headers" :items="turmas" :sort-desc="true" class="elevation-1" :search="search">

      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-progress-circular :size="50" color="green" indeterminate v-if="isLoading"></v-progress-circular>
          <!-- <v-btn
          to="/menu-pauta"
          class="mx-2"
          fab
          dark
          color="primary"
        >
          <v-icon dark>arrow_back</v-icon>
        </v-btn> -->

          <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>
            Turma(s) da
            <span v-if="idclasse === 1">10ª classe</span>
            <span v-if="idclasse === 2">11ª classe</span>
            <span v-if="idclasse === 3">12ª classe</span>
            <span v-if="idclasse === 4">13ª classe</span>
          </v-toolbar-title>
          <v-divider class="mx-8" inset vertical></v-divider>
          <span>Selecionado : <strong style="font-size:22px;">{{ $store.state.novadescricaoSelecionado
              }}</strong></span>
          <!--  search  -->
          <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
            {{ $store.state.textMessage }}
          </div>

          <div class="flex-grow-1"></div>

          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          <!-- end  search  -->

          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">

            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }} -</span>
                <span v-if="idclasse === 1">10ª classe</span>
                <span v-if="idclasse === 2">11ª classe</span>
                <span v-if="idclasse === 3">12ª classe</span>
                <span v-if="idclasse === 4">13ª classe</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form ref="form" v-model="formValid" lazy-validation>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
                          {{ $store.state.textMessage }}
                        </div>

                        <span v-if="sala && flag_curso && editedItem.periodo.value" ref="myid">
                          {{
                            flag_curso
                              .trim()
                              .toUpperCase()
                              .substring(0, 3)
                              .concat("-")
                              .concat("SALA " + sala.padStart(2, "0") + "-")
                              .concat(editedItem.periodo.value + "-" + classeTur)
                          }}
                        </span>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-combobox v-model="editedItem.idCurso" item-text="descricao"
                          @change="createdTurmaflag_description" :items="cursos" chips label="Curso"></v-combobox>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field :rules="notaRules" v-model="sala" label="Sala"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-combobox v-model="editedItem.periodo" item-value="value" item-text="descricao"
                          :items="periodos" chips label="Periodo"></v-combobox>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" v-if="
                  !(formValid && sala && flag_curso && editedItem.periodo.value)
                " text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon class="mr-2" @click=" criarPdf(item)" color="primary">print</v-icon>
      </template>
      <template v-slot:no-data>
        no data
      </template>
    </v-data-table>



    <!-- ************************************************************************* -->


    <v-dialog v-model="dialogOpcoes" persistent max-width="490">

      <v-card>
        <v-card-title class="text-h5">
          Opções de Impressão
        </v-card-title>
        <v-card-text>
          <label>Selecione a opção de impressão</label>
          <v-row>
            <v-col md="12">
              <v-combobox v-model="opcaoImpressao" :items="[
                { id: 3, descricao: 'Todos' },
                { id: 1, descricao: 'Apenas os Aprovados' },
                { id: 2, descricao: 'Apenas os Reprovados' },
                { id: 4, descricao: 'Apenas os Exames' },
                { id: 5, descricao: 'Apenas os Recursos' },
              ]" label="Selecione" item-text="descricao" item-value="id" required return-object>

              </v-combobox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogOpcoes = false">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text @click="callGerarPauta()">
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <GlobalSnackbar ref="snackbar"/>
    <!-- ***************************************************************************** -->
  </div>
</template>
<script>
import axios from '../../plugins/axios'
// import jsreport from 'jsreport-browser-client-dist/jsreport'
const ls = require('local-storage')
// const fs = require('fs')
// const request = require('request')
const help = require('../../../Helpers/Helpers')
export default {
  data: () => ({
    readImage: `http://eftsl.softlineangola.com:8082/readfile/`,
    option: {
      'format': 'A3',
      'orientation': 'landscape',
      paginationOffset: 2,
      'header': {
        'height': '10mm',
        'contents': '<div style="text-align: center;">Author: Marc Bachmann</div>'
      },
      'footer': {
        'height': '5mm'
      }
    },
    url: ``,
    text: '',
    flag_curso: '',
    formValid: true,
    alunosTurma: [],
    flag_periodo: '',
    flag_sala: '',
    flag_class: '',
    sala: '',
    search: '',
    quant: 0,
    cursos: [],
    html: ``,
    disciplinas: [],
    notas: [],
    isLoading: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    periodos: [
      { descricao: 'Manhã', value: 'M' },
      { descricao: 'Tarde', value: 'T' }
    ],
    turmas: [],
    dialog: false,
    headers: [
      {
        text: 'descricao',
        align: 'left',
        sortable: false,
        value: 'turmadescricao'
      },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Numero de Alunos', value: 'quantalunos' },
      { text: 'Modificado', value: 'data_2' },
      { text: 'Acção', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idCurso: 0,
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    },
    defaultItem: {
      idCurso: 0,
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    },
    opcaoImpressao: null,
    objectoTurma: null,
    dialogOpcoes: false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nova Turma' : 'Editar Turma'
    },

    idclasse() {
      return this.$store.state.idclasse
    },
    classeTur() {
      return this.$store.state.classeTur
    },
    instituicaodescricao() {
      return ls.get('instituicaodescricao')
    },

    instituicaoId() {
      return ls.get('i_id')
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initializeCursos()
    this.initializeturmasAll()
  },

  methods: {
    createdTurmaflag_description() {
      this.flag_curso = this.editedItem.idCurso.descricao
    },

    descricaoEscola() {

      return (this.instituicaoId === 1) ? 'INSTITUTO TÉCNICO DE SAÚDE DE LUANDA' : this.instituicaodescricao.toUpperCase()
    },

    getClasseDescricao(idclasse) {

      switch (idclasse) {
        case 1:
          return '10ª Classe'
        case 2:
          return '11ª Classe'
        case 3:
          return '12ª Classe'
        case 4:
          return '13ª Classe'

        default:
          break;
      }


    },

    async initializeCursos() {
      try {
        this.cursos = await axios.get('/cursoFindAll').then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeturmasAll() {
      try {
        this.isLoading = true
        this.turmas = await axios
          .get('/turmaFindAll-Anolectivo/' + this.$store.state.anolectivoSelecionado + '/' + this.$store.state.idclasse)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    editItem(item) {
      this.editedIndex = this.turmas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.turmas.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.turmas.splice(index, 1)
      this.EliminaTurma(item)
    },
    async EliminaTurma(item) {
      try {
        this.alunosTurma = await axios.get('/turmaFindCountPk/' + item.pkTurma).then(res => res.data)
        if (!this.alunosTurma.length) {
          this.Eliminar(item)
        } else {
          this.text = 'Está turma não pode ser eliminada'
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 2000
          })
        }
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async Eliminar(item) {
      try {
        this.msg = await axios
          .get('/EliminarTurma/' + item.pkTurma)
          .then(res => res.data)

        this.text = this.msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 4000
        })
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    ListagemEstudantes(item) {
      this.$store.state.objturma = item
      this.$router.push('ListaAlunos')
    },
    zebraPauta(i) {
      if (i % 2) {
        return 'zebr'
      } else {
        return ''
      }
    },
    async pautasgerarpdf(options) {
      this.isLoading = true
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: options
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        // Imprimir PDF

        this.isLoading = false
        this.frame()
        this.$refs.snackbar.mostrar("Pauta gerada com sucesso!", "success", "top");
      } catch (error) {
        this.isLoading = false
        this.$refs.snackbar.mostrar("Ocorreu um erro ao carregar as notas!", "error", "top");
      }
    },
    frame() {
      this.isLoading = false
      this.url = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + this.url + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },
    comporHtmlPauta4(dados, notas) {
      let options = {
        'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '12mm'
        },
        'footer': {
          'height': '18mm'
        }
      }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `  <tr class="` + this.zebraPauta(i) + `">
                    <td align="center" height="20">
                        ` + i + `
                    </td>
                    <td>
                         ` + element.nome + `
                    </td>
                      <td>
                          ` + this.isNull(element.ca_a_0) + `
                    </td>
                    <td>
                           ` + this.isNull(element.mf_0) + `
                    </td>
                     <td>
                        ` + this.isNull(element.pg_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_0) + `
                    </td>
                    <td>
                        ` + this.isNull(element.mfd_0) + ` 
                    </td>
                    <td>
                          ` + this.isNull(element.ex_0) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_1) + `
                    </td>
                    <td>
                            ` + this.isNull(element.mf_1) + `
                    </td>
                     <td align="center" height="20">
                        ` + this.isNull(element.pg_1) + ` 
                    </td>
                    <td>
                         ` + this.isNull(element.ca_1) + ` 
                    </td>
                    <td>
                       ` + this.isNull(element.mfd_1) + ` 
                    </td>
                    <td>
                          ` + this.isNull(element.ex_1) + ` 
                    </td>
                      <td>
                         ` + this.isNull(element.ca_a_2) + `
                    </td>
                    <td>
                          ` + this.isNull(element.mf_2) + `
                    </td>
                     <td>
                        ` + this.isNull(element.pg_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_2) + `
                    </td>
                    <td>
                          ` + this.isNull(element.mfd_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_2) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_3) + `
                    </td>
                    <td>
                          ` + this.isNull(element.mf_3) + `
                    </td>
                     <td>
                        ` + this.isNull(element.pg_3) + `
                    </td>
                    <td>
                          ` + this.isNull(element.ca_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_3) + `
                    </td>
                    <td>
                          ` + this.isNull(element.ex_3) + `
                    </td>
 
                    <td class="NaoTransita" >
                     <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                      </td> 
                </tr>
        `
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>
        .invoice-box table tr.heading td {
    background: #eee;
    border-bottom: 1px solid #ddd;
    font-weight: bold;
}

             table.report-container {
      page-break-after:always;
      
}
thead.report-header {
      display:table-header-group;
}
 .zebr{
        background-color: #DCDCDC;
    }
tfoot.report-footer {
      display:table-footer-group;
} 
            td.ex2 {
  width: 10px;
  padding:60px;
  _width: 105px;
	}
   table.ex1 {
  margin:30;
  font-size:10px;
}
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
    
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
pre {
  display: block;
  font-family:  "Times New Roman", Times, serif;
  white-space: pre;
}
        </style>
    </head>
    <body>
     <pre id="t1" style="padding-left:800px; font: 12px Andale Mono, monospace;">                                                                                                                                                                                                                                                                                                                                           
           <span style="padding-left:90px">Visto</span><br>
       _________________________________
          <span style="padding-left:70px;">Director Geral</span>
          </pre>
        
        <div align="center">

            <table border="0" cellpadding="0" cellspacing="0">

                <tr>

                    <td colspan="4">
                        <center>  <img src=` + ls.get('insignia') + ` alt="Snow" style="width:25%; max-width:50px;" />
               <br></br><center style="font-size:12px"> REPÚBLICA DE ANGOLA <br>
                           MINISTÉRIO DA EDUCAÇÃO <br>
                           GOVERNO DA PROVÍNCIA DE LUANDA <br>
                          `+ this.descricaoEscola() + `<br><br>
                           PAUTA GERAL</center>

                    </td>
                </tr>
                  </table>
        </div>
        <div align="center">
        <table  style="padding-top:18px;" border="0" cellpadding="0" cellspacing="0">
         <tr class="heading">
                    <td align="left" rowspan="1" style=" font: 10px Andale Mono, monospace;">
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      Classe: &nbsp; <u> `+ this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>
          </div>
            </table>

          <div>

            <table class="ex1" BORDER=1 cellspacing="0" >
            <thead class="report-header">
               <tr class="heading">
               <td rowspan="2" >Nº</td>
               <td rowspan="2" class="ex2"   >Nome </td>
               <td align="center" colspan="6" bgcolor="#DCDCDC" >` + dados[0].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[3].disciplina + `</thd>
               <td colspan="1"  height="80" width="50"> </td>
  </tr>
    <tr   class="heading">
                     <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td> 
                     <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                  
                     <td align="center" height="40"  width="60">
                   Resultado
                    </td>        
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
        <br></br>
         <footer>

 <table  class="ex1" BORDER=0 cellspacing="0" class="report-container" >
 <tr>
   <td>
        <span style="padding-left:20px; font-size:10px;">O Cordenador do Curso</span><br></br>
         <span>________________________________________</span>
    </td>
     <td>
       <div><span style="padding-left:250px;font: 10px Andale Mono, monospace;" >Luanda, ` + help.presente_data() + `</span></div>
    </td>
     <td>
        <span style="padding-left:290px; font-size:10px;"> A sub-Directora Pedagógica</span><br></br>
        <span style="padding-left:240px;"> ________________________________________</span>
    </td>
 </tr>
          </table>

</footer>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta8(dados, notas) {
      let options = {
        'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '14mm'
        },
        'footer': {
          'height': '8mm'
        }
      }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
        <tr class="` + this.zebraPauta(i) + `">
                    <td style="font-size:8px" align="center" height="20">
                        ` + i + `
                    </td>
                    <td style="font-size:8px">
                         ` + element.nome + `
                    </td>
                     <td>
                        ` + this.isNull(element.ca_a_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_0) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_2) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_3) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_4) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_5) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_6) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_7) + `
                    </td>
                     <td class="NaoTransita" >
                     <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                      </td> 
                </tr>`
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>

           table.report-container {
      page-break-after:always;

}
thead.report-header {
      display:table-header-group;
}
 .zebr{
        background-color: #DCDCDC;
    }
tfoot.report-footer {
      display:table-footer-group;
}
           td.ex2 {
  width:10px;
  padding:60px;
  _width: 105px;
	}
   table.ex1 {
  margin:30;
  font-size:6px;
}
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
     .zebr{
        background-color: #DCDCDC;
    }
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
pre {
  display: block;
  font-family:  "Times New Roman", Times, serif;
  white-space: pre;
}
        </style>
    </head>
    <body>
      <pre id="t1" style="padding-left:800px; font: 12px Andale Mono, monospace;">                                                                                                                                                                                                                                                                                                                                           
           <span style="padding-left:90px">Visto</span><br>
       _________________________________
          <span style="padding-left:70px;">Director Geral</span>
          </pre>
        <div align="center">

            <table border="0" cellpadding="0" cellspacing="0">

                <tr>

                    <td colspan="4">
                        <center>  <img src=` + ls.get('insignia') + `  alt="Snow" style="width:25%; max-width:50px;" />
               <br></br><center style="font-size:12px"> REPÚBLICA DE ANGOLA <br>
                           MINISTÉRIO DA EDUCAÇÃO <br>
                           GOVERNO DA PROVÍNCIA DE LUANDA <br>
                          `+ this.descricaoEscola() + `<br><br>
                           PAUTA GERAL</center>

                    </td>
                </tr>
                  </table>
        </div>
        <div align="center">
        <table  style="padding-top:18px;" border="0" cellpadding="0" cellspacing="0">
         <tr class="heading">
                    <td align="left" rowspan="1" style=" font: 10px Andale Mono, monospace;">
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      Classe: &nbsp; <u> `+ this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>
          </div>
            </table>

          <div>

            <table class="ex1" BORDER=1 cellspacing="0" class="report-container">
               <thead class="report-header">
               <tr class="heading">
               <td rowspan="2"style="font-size:10px" >Nº</td>
               <td rowspan="2" class="ex2" style="font-size:10px">Nome </td>
               <td align="center" colspan="6" width="60" bgcolor="#DCDCDC" style="font-size:10px" >` + dados[0].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[1].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[2].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[3].disciplina + `</td>
               <td align="center" colspan="6" width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[4].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[5].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[6].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[7].disciplina + `</td>
               <td colspan="1"  height="80" width="50"> </td>
  </tr>
      <tr   class="heading">
                 <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td> 
                     <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                     <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                     <td align="center" height="40"  width="60">
                   Resultado
                    </td>           
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
        
         <footer>

 <table  class="ex1" BORDER=0 cellspacing="0" class="report-container" >
 <tr>
   <td>
        <span style="padding-left:20px; font-size:10px;">O Cordenador do Curso</span><br></br>
         <span>_____________________________________________________</span>
    </td>
     <td>
       <div><span style="padding-left:280px;font: 10px Andale Mono, monospace;" >Luanda, ` + help.presente_data() + `</span></div>
    </td>
     <td>
        <span style="padding-left:300px; font-size:10px;"> A sub-Directora Pedagógica</span><br></br>
        <span style="padding-left:280px;"> _____________________________________________________</span>
    </td>
 </tr>
          </table>

</footer>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta9(dados, notas) {
      let options = {
        'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '14mm'
        },
        'footer': {
          'height': '7mm'
        }
      }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
        <tr class="` + this.zebraPauta(i) + `">
                    <td align="center" height="20" style="font-size:8px">
                        ` + i + `
                    </td>
                    <td style="font-size:8px">
                         ` + element.nome + `
                    </td>
                     <td>
                       ` + this.isNull(element.ca_a_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_0) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_2) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_3) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_4) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_5) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_6) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_7) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_8) + `
                    </td>
                     <td class="NaoTransita" >
                     <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                      </td> 
                </tr>`
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>

           table.report-container {
      page-break-after:always;

}
thead.report-header {
      display:table-header-group;
}
 .zebr{
        background-color: #DCDCDC;
    }
tfoot.report-footer {
      display:table-footer-group;
}
           td.ex2 {
  width: 10px;
  padding:60px;
  _width: 105px;
	}
   table.ex1 {
  margin:30;
  font-size:6px;
}
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
     .zebr{
        background-color: #DCDCDC;
    }
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
pre {
  display: block;
  font-family:  "Times New Roman", Times, serif;
  white-space: pre;
}
        </style>
    </head>
    <body>
      <pre id="t1" style="padding-left:800px; font: 12px Andale Mono, monospace;">                                                                                                                                                                                                                                                                                                                                           
           <span style="padding-left:90px">Visto</span><br>
       _________________________________
          <span style="padding-left:70px;">Director Geral</span>
          </pre>

        <div align="center">

            <table border="0" cellpadding="0" cellspacing="0">

                <tr>

                    <td colspan="4">
                        <center>  <img src=` + ls.get('insignia') + `  alt="Snow" style="width:25%; max-width:50px;" />
               <br></br><center style="font-size:12px"> REPÚBLICA DE ANGOLA <br>
                           MINISTÉRIO DA EDUCAÇÃO <br>
                           GOVERNO DA PROVÍNCIA DE LUANDA <br>
                          `+ this.descricaoEscola() + `<br><br>
                           PAUTA GERAL</center>

                    </td>
                </tr>
                  </table>
        </div>
        <div align="center">
        <table  style="padding-top:18px;" border="0" cellpadding="0" cellspacing="0">
         <tr class="heading">
                    <td align="left" rowspan="1" style=" font: 10px Andale Mono, monospace;">
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      Classe: &nbsp; <u> `+ this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>
          </div>
            </table>

          <div>

            <table class="ex1" BORDER=1 cellspacing="0">
               <thead class="report-header">
               <tr class="heading">
               <td rowspan="2" style="font-size:10px">Nº</td>
               <td rowspan="2" class="ex2" style="font-size:10px">Nome </td>
               <td align="center" colspan="6" width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[0].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[1].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[2].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[3].disciplina + `</td>
               <td align="center" colspan="6" width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[4].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[5].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[6].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[7].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[8].disciplina + `</td>
               <td colspan="1"  height="80" width="50"> </td>
  </tr>
      <tr   class="heading">
                  <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td> 
                     <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                     <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                     <td align="center" height="40"  width="70">
                   Resultado
                    </td>            
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
        <br></br>
         <footer>

 <table  class="ex1" BORDER=0 cellspacing="0" class="report-container" >
 <tr>
   <td>
        <span style="padding-left:20px; font-size:10px;">O Cordenador do Curso</span><br></br>
         <span>_____________________________________________________</span>
    </td>
     <td>
       <div><span style="padding-left:280px;font: 10px Andale Mono, monospace;" >Luanda, ` + help.presente_data() + `</span></div>
    </td>
     <td>
        <span style="padding-left:300px; font-size:10px;"> A sub-Directora Pedagógica</span><br></br>
        <span style="padding-left:280px;"> _____________________________________________________</span>
    </td>
 </tr>
          </table>

</footer>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta10(dados, notas) {
      let options = {
        'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '14mm'
        },
        'footer': {
          'height': '7mm'
        }
      }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
        <tr class="` + this.zebraPauta(i) + `">
                    <td align="center" height="20" style="font-size:8px">
                        ` + i + `
                    </td>
                    <td style="font-size:8px">
                         ` + element.nome + `
                    </td>
                       ` + this.isNull(element.ca_a_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_0) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_2) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_3) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_4) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_5) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_6) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_7) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_8) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_9) + `
                    </td>

                     <td class="NaoTransita" >
                     <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                      </td> 
                </tr>`
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>

           table.report-container {
      page-break-after:always;

}
thead.report-header {
      display:table-header-group;
}
 .zebr{
        background-color: #DCDCDC;
    }
tfoot.report-footer {
      display:table-footer-group;
}
           td.ex2 {
  width: 10px;
  padding:60px;
  _width: 105px;
	}
   table.ex1 {
  margin:30;
  font-size:6px;
}
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
     .zebr{
        background-color: #DCDCDC;
    }
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
pre {
  display: block;
  font-family:  "Times New Roman", Times, serif;
  white-space: pre;
}
        </style>
    </head>
    <body>
       <pre id="t1" style="padding-left:800px; font: 12px Andale Mono, monospace;">                                                                                                                                                                                                                                                                                                                                           
           <span style="padding-left:90px">Visto</span><br>
       _________________________________
          <span style="padding-left:70px;">Director Geral</span>
          </pre>

        <div align="center">

            <table border="0" cellpadding="0" cellspacing="0">

                <tr>

                    <td colspan="4">
                        <center>  <img src=` + ls.get('insignia') + `  alt="Snow" style="width:25%; max-width:50px;" />
               <br></br><center style="font-size:12px"> REPÚBLICA DE ANGOLA <br>
                           MINISTÉRIO DA EDUCAÇÃO <br>
                           GOVERNO DA PROVÍNCIA DE LUANDA <br>
                          `+ this.descricaoEscola() + `<br><br>
                           PAUTA GERAL</center>

                    </td>
                </tr>
                  </table>
        </div>
        <div align="center">
        <table  style="padding-top:18px;" border="0" cellpadding="0" cellspacing="0">
         <tr class="heading">
                    <td align="left" rowspan="1" style=" font: 10px Andale Mono, monospace;">
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      Classe: &nbsp; <u> `+ this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>
          </div>
            </table>

          <div>

            <table class="ex1" BORDER=1 cellspacing="0" class="report-container">
               <thead class="report-header">
               <tr class="heading">
               <td rowspan="2" style="font-size:10px">Nº</td>
               <td rowspan="2" class="ex2"  style="font-size:10px" >Nome </td>
               <td align="center" colspan="6" width="60" bgcolor="#DCDCDC" >` + dados[0].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[3].disciplina + `</td>
               <td align="center" colspan="6" width="60" bgcolor="#DCDCDC" >` + dados[4].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[5].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[6].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[7].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[8].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC">` + dados[9].disciplina + `</td>
               <td colspan="1"  height="80" width="50"> </td>
  </tr>
      <tr   class="heading">
               <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                   <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                     <td align="center" height="40"  width="120">
                   Resultado
                    </td>              
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
        <br></br>
         <footer>

 <table  class="ex1" BORDER=0 cellspacing="0" class="report-container" >
 <tr>
    <td>
        <span style="padding-left:20px; font-size:10px;">O Cordenador do Curso</span><br></br>
         <span>_____________________________________________________</span>
    </td>
     <td>
       <div><span style="padding-left:350px;font: 10px Andale Mono, monospace;" >Luanda, ` + help.presente_data() + `</span></div>
    </td>
     <td>
        <span style="padding-left:300px; font-size:10px;"> A sub-Directora Pedagógica</span><br></br>
        <span style="padding-left:280px;"> _____________________________________________________</span>
    </td>
 </tr>
          </table>

</footer>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta11(dados, notas) {
      let options = {
        'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '12mm'
        },
        'footer': {
          'height': '5mm'
        }
      }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
        <tr class="` + this.zebraPauta(i) + `">
                    <td align="center" height="20" style="font-size:10px">
                        ` + i + `
                    </td>
                    <td style="font-size:8px">
                         ` + element.nome + `
                    </td>
                     <td>
                        ` + this.isNull(element.ca_a_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_0) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_2) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_3) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_4) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_5) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_6) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_7) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_8) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_9) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_10) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_10) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_10) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_10) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_10) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_10) + `
                    </td>

                     <td class="NaoTransita" >
                     <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                      </td> 
                </tr>`
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>

           table.report-container {
      page-break-after:always;

}
thead.report-header {
      display:table-header-group;
}
 .zebr{
        background-color: #DCDCDC;
    }
tfoot.report-footer {
      display:table-footer-group;
}
           td.ex2 {
  width: 10px;
  padding:60px;
  _width: 105px;
	}
   table.ex1 {
  margin:30;
  font-size:6px;
}
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
     .zebr{
        background-color: #DCDCDC;
    }
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
pre {
  display: block;
  font-family:  "Times New Roman", Times, serif;
  white-space: pre;
}
        </style>
    </head>
    <body>
       <pre id="t1" style="padding-left:800px; font: 12px Andale Mono, monospace;">                                                                                                                                                                                                                                                                                                                                           
           <span style="padding-left:90px">Visto</span><br>
       _________________________________
          <span style="padding-left:70px;">Director Geral</span>
          </pre>

        <div align="center">

            <table border="0" cellpadding="0" cellspacing="0">

                <tr>

                    <td colspan="4">
                        <center>  <img src=` + ls.get('insignia') + `  alt="Snow" style="width:25%; max-width:50px;" />
               <br></br><center style="font-size:12px"> REPÚBLICA DE ANGOLA <br>
                           MINISTÉRIO DA EDUCAÇÃO <br>
                           GOVERNO DA PROVÍNCIA DE LUANDA <br>
                          `+ this.descricaoEscola() + `<br><br>
                           PAUTA GERAL</center>

                    </td>
                </tr>
                  </table>
        </div>
        <div align="center">
        <table  style="padding-top:18px;" border="0" cellpadding="0" cellspacing="0">
         <tr class="heading">
                    <td align="left" rowspan="1" style=" font: 10px Andale Mono, monospace;">
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      Classe: &nbsp; <u> `+ this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>
          </div>
            </table>

          <div>

            <table class="ex1" BORDER=1 cellspacing="0" class="report-container">
               <thead class="report-header">
               <tr class="heading">
               <td rowspan="2" style="font-size:10px">Nº</td>
               <td rowspan="2" class="ex2"   style="font-size:10px">Nome </td>
               <td align="center" colspan="6" width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[0].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[1].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[2].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[3].disciplina + `</td>
               <td align="center" colspan="6" width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[4].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[5].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[6].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[7].disciplina + `</td>
                <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[8].disciplina + `</td>
               <td align="center" colspan="6"  width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[9].disciplina + `</td>
               <td align="center" colspan="6" width="60" bgcolor="#DCDCDC" style="font-size:10px">` + dados[10].disciplina + `</td>
               <td colspan="1"  height="80" width="50"> </td>
  </tr>
      <tr   class="heading">
                <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                      
                     <td align="center" height="40"  width="120">
                   Resultado
                    </td>        
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
        <br></br>
         <footer>

 <table  class="ex1" BORDER=0 cellspacing="0" class="report-container" >
 <tr>
   <td>
        <span style="padding-left:20px; font-size:10px;">O Cordenador do Curso</span><br></br>
         <span>_____________________________________________________</span>
    </td>
     <td>
       <div><span style="padding-left:280px;font: 10px Andale Mono, monospace;" >Luanda, ` + help.presente_data() + `</span></div>
    </td>
     <td>
        <span style="padding-left:300px; font-size:10px;"> A sub-Directora Pedagógica</span><br></br>
        <span style="padding-left:280px;"> _____________________________________________________</span>
    </td>
 </tr>
          </table>

</footer>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta12(dados, notas) {
      let options = {
        'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '14mm'
        },
        'footer': {
          'height': '5mm'
        }
      }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
        <tr class="` + this.zebraPauta(i) + `">
                    <td align="center" height="20" style="font-size:8px">
                        ` + i + `
                    </td>
                    <td style="font-size:8px">
                         ` + element.nome + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_0) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_0) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_2) + `
                    </td>

                      <td>
                         ` + this.isNull(element.ca_a_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_3) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_3) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_4) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_4) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_5) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_5) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_6) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_6) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_7) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_7) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_8) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_8) + `
                    </td>

                     <td>
                         ` + this.isNull(element.ca_a_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_9) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_9) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_10) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_10) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_10) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_10) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_10) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_10) + `
                    </td>
                     <td>
                         ` + this.isNull(element.ca_a_11) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mf_11) + `
                    </td>
                    <td>
                         ` + this.isNull(element.pg_11) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ca_11) + `
                    </td>
                    <td>
                         ` + this.isNull(element.mfd_11) + `
                    </td>
                    <td>
                         ` + this.isNull(element.ex_11) + `
                    </td>



                     <td class="NaoTransita" >
                     <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                      </td> 
                </tr>`
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>

          
 .zebr{
        background-color: #DCDCDC;
    }
tfoot.report-footer {
      display:table-footer-group;
}
          
   table.ex1 {
  margin:20;
  font-family: "Andale Mono, monospace";
  font-size:6px;
}
  td.ex2 {
  width: 7px;
  padding:50px;
  _width: 50px;
	}
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
     .zebr{
        background-color: #DCDCDC;
    }
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
pre {
  display: block;
  font-family: "Andale Mono, monospace";
  white-space: pre;
}
.row-item:nth-child(20n) {
    page-break-after: always;
    page-break-inside: avoid;
}

        </style>
    </head>
    <body>
      <pre id="t1" style="padding-left:800px; font: 12px Andale Mono, monospace;">                                                                                                                                                                                                                                                                                                                                           
           <span style="padding-left:90px">Visto</span><br>
       _________________________________
          <span style="padding-left:70px;">Director Geral</span>
          </pre>

        <div align="center">

            <table border="0" cellpadding="0" cellspacing="0">

                <tr>

                    <td colspan="4">
                        <center>  <img src=` + ls.get('insignia') + ` alt="Snow" style="width:25%; max-width:50px;" />
               <br></br><center style="font-size:12px"> REPÚBLICA DE ANGOLA <br>
                           MINISTÉRIO DA EDUCAÇÃO <br>
                           GOVERNO DA PROVÍNCIA DE LUANDA <br>
                          `+ this.descricaoEscola() + `<br><br>
                           PAUTA GERAL</center>

                    </td>
                </tr>
                  </table>
        </div>
        <div align="center">
        <table style="padding-top:18px;" border="0" cellpadding="0" cellspacing="0">
         <tr class="heading">
                    <td align="left" rowspan="1" style=" font: 10px Andale Mono, monospace;">
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      Classe: &nbsp; <u> `+ this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  style=" font: 10px Andale Mono, monospace;">
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>
          </div>
            </table>

          <div >

            <table style="width:5%"  BORDER=1 cellspacing="0" class="ex1" class="row-item">
               <thead>
               <tr class="heading">
               <td rowspan="2" style="font-size:10px">Nº</td>
               <td rowspan="2" width="50px" class="ex2" style="font-size:10px">Nome </td>
               <td align="center" colspan="6"  bgcolor="#DCDCDC" style="font-size:10px">` + dados[0].disciplina + `</td>
               <td align="center" colspan="6"   bgcolor="#DCDCDC" style="font-size:10px">` + dados[1].disciplina + `</td>
                <td align="center" colspan="6"   bgcolor="#DCDCDC" style="font-size:10px">` + dados[2].disciplina + `</td>
               <td align="center" colspan="6"   bgcolor="#DCDCDC" style="font-size:10px">` + dados[3].disciplina + `</td>
               <td align="center" colspan="6"  bgcolor="#DCDCDC" style="font-size:10px">` + dados[4].disciplina + `</td>
               <td align="center" colspan="6"   bgcolor="#DCDCDC" style="font-size:10px">` + dados[5].disciplina + `</td>
                <td align="center" colspan="6"   bgcolor="#DCDCDC" style="font-size:10px">` + dados[6].disciplina + `</td>
               <td align="center" colspan="6"   bgcolor="#DCDCDC" style="font-size:10px">` + dados[7].disciplina + `</td>
                <td align="center" colspan="6"   bgcolor="#DCDCDC" style="font-size:10px">` + dados[8].disciplina + `</td>
               <td align="center" colspan="6"   bgcolor="#DCDCDC" style="font-size:10px">` + dados[9].disciplina + `</td>
               <td align="center" colspan="6"  bgcolor="#DCDCDC" style="font-size:10px">` + dados[10].disciplina + `</td>
               <td align="center" colspan="6"   bgcolor="#DCDCDC" style="font-size:10px">` + dados[11].disciplina + `</td>
               <td colspan="1"  height="80" > </td>
  </tr>
      <tr   class="heading">
            <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td><td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                    <td align="center" height="40"  width="30">
                      MF
                    </td>
                    <td align="center" height="40"  width="30">
                       PG
                    </td>
                    <td align="center" height="40"  width="30">
                       CA
                    </td>
                     <td align="center" height="40"  width="30">
                       MF
                    </td>
                    <td align="center" height="40"  width="30">
                       EX
                    </td>                     
                     <td align="center" height="40"  width="30">
                   Resultado
                    </td>              
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
      
         <footer>

 <table  class="ex1" BORDER=0 cellspacing="0">
 <tr>
    <td>
        <span style="padding-left:20px; font-size:10px;">O Cordenador do Curso</span><br></br>
         <span>_____________________________________________________</span>
    </td>
     <td>
       <div><span style="padding-left:300px;font: 10px Andale Mono, monospace;" >Luanda, ` + help.presente_data() + `</span></div>
    </td>
     <td>
        <span style="padding-left:300px; font-size:10px;"> A sub-Directora Pedagógica</span><br></br>
        <span style="padding-left:280px;"> _____________________________________________________</span>
    </td>
 </tr>
          </table>

</footer>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    isNull(notaPauta) {
      if (notaPauta) { return notaPauta } else return ''
    },

    async criarPdf(item) {
      this.dialogOpcoes = true
      this.objectoTurma = item
    },

    async callGerarPauta() {
      if (!this.opcaoImpressao) {
        this.$refs.snackbar.mostrar("Selecione uma opção!", "error", "top");
        return
      }

      this.dialogOpcoes = false
      this.gerarPauta(this.objectoTurma)
    },


    FiltroOpcoesImpressao(notas) {

      if (this.opcaoImpressao.id === 1) {
        return notas.filter(f => f.resultado.trim().toLowerCase() === 'transita')
      } else if (this.opcaoImpressao.id === 2) {
        return notas.filter(f => f.resultado.trim().toLowerCase() === 'não transita')
      }

      else if (this.opcaoImpressao.id === 4) {
        return notas.filter(f => f.resultado.trim().toLowerCase() === 'exame')
      }
      else if (this.opcaoImpressao.id === 5) {
        return notas.filter(f => f.resultado.trim().toLowerCase() === 'recurso')
      }
      else {
        return notas
      }

    },
    async gerarPauta(item) {
      this.isLoading = true
      const valor = {
        turma: item.pkTurma,
        ano: item.idAno_Academico
      }
      console.log(valor);
      let camposPauta = {}
      try {
        this.disciplinas = await axios
          .post('/discipautageral', valor)
          .then(res => res.data)

        if (this.disciplinas.length > 0) this.disciplinas = this.disciplinas[0]
        if (this.disciplinas.length === 4) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            quant: 4
          }
        } else
          if (this.disciplinas.length === 8) {
            camposPauta = {
              turma: this.disciplinas[0].pkTurma,
              ano: this.disciplinas[0].anoLectivo,
              d0: this.disciplinas[0].iddisciplina,
              d1: this.disciplinas[1].iddisciplina,
              d2: this.disciplinas[2].iddisciplina,
              d3: this.disciplinas[3].iddisciplina,
              d4: this.disciplinas[4].iddisciplina,
              d5: this.disciplinas[5].iddisciplina,
              d6: this.disciplinas[6].iddisciplina,
              d7: this.disciplinas[7].iddisciplina,
              quant: 8
            }
          } else
            if (this.disciplinas.length === 9) {
              camposPauta = {
                turma: this.disciplinas[0].pkTurma,
                ano: this.disciplinas[0].anoLectivo,
                d0: this.disciplinas[0].iddisciplina,
                d1: this.disciplinas[1].iddisciplina,
                d2: this.disciplinas[2].iddisciplina,
                d3: this.disciplinas[3].iddisciplina,
                d4: this.disciplinas[4].iddisciplina,
                d5: this.disciplinas[5].iddisciplina,
                d6: this.disciplinas[6].iddisciplina,
                d7: this.disciplinas[7].iddisciplina,
                d8: this.disciplinas[8].iddisciplina,
                quant: 9
              }
            } else
              if (this.disciplinas.length === 10) {
                camposPauta = {
                  turma: this.disciplinas[0].pkTurma,
                  ano: this.disciplinas[0].anoLectivo,
                  d0: this.disciplinas[0].iddisciplina,
                  d1: this.disciplinas[1].iddisciplina,
                  d2: this.disciplinas[2].iddisciplina,
                  d3: this.disciplinas[3].iddisciplina,
                  d4: this.disciplinas[4].iddisciplina,
                  d5: this.disciplinas[5].iddisciplina,
                  d6: this.disciplinas[6].iddisciplina,
                  d7: this.disciplinas[7].iddisciplina,
                  d8: this.disciplinas[8].iddisciplina,
                  d9: this.disciplinas[9].iddisciplina,
                  quant: 10
                }
              } else
                if (this.disciplinas.length === 11) {
                  camposPauta = {
                    turma: this.disciplinas[0].pkTurma,
                    ano: this.disciplinas[0].anoLectivo,
                    d0: this.disciplinas[0].iddisciplina,
                    d1: this.disciplinas[1].iddisciplina,
                    d2: this.disciplinas[2].iddisciplina,
                    d3: this.disciplinas[3].iddisciplina,
                    d4: this.disciplinas[4].iddisciplina,
                    d5: this.disciplinas[5].iddisciplina,
                    d6: this.disciplinas[6].iddisciplina,
                    d7: this.disciplinas[7].iddisciplina,
                    d8: this.disciplinas[8].iddisciplina,
                    d9: this.disciplinas[9].iddisciplina,
                    d10: this.disciplinas[10].iddisciplina,
                    quant: 11
                  }
                } else
                  if (this.disciplinas.length === 12) {
                    camposPauta = {
                      turma: this.disciplinas[0].pkTurma,
                      ano: this.disciplinas[0].anoLectivo,
                      d0: this.disciplinas[0].iddisciplina,
                      d1: this.disciplinas[1].iddisciplina,
                      d2: this.disciplinas[2].iddisciplina,
                      d3: this.disciplinas[3].iddisciplina,
                      d4: this.disciplinas[4].iddisciplina,
                      d5: this.disciplinas[5].iddisciplina,
                      d6: this.disciplinas[6].iddisciplina,
                      d7: this.disciplinas[7].iddisciplina,
                      d8: this.disciplinas[8].iddisciplina,
                      d9: this.disciplinas[9].iddisciplina,
                      d10: this.disciplinas[10].iddisciplina,
                      d11: this.disciplinas[10].iddisciplina,
                      quant: 12
                    }
                  }
        this.notas = await axios
          .post('/pautageral', camposPauta)
          .then(res => res.data)
        console.log(this.disciplinas.length);
        if (this.disciplinas.length === 4) { this.comporHtmlPauta4(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
          if (this.disciplinas.length === 3) { this.comporHtmlPauta3(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
            if (this.disciplinas.length === 2) { this.comporHtmlPauta2(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
              if (this.disciplinas.length === 6) { this.comporHtmlPauta6(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
                if (this.disciplinas.length === 7) { this.comporHtmlPauta7(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
                  if (this.disciplinas.length === 8) { this.comporHtmlPauta8(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
                    if (this.disciplinas.length === 9) { this.comporHtmlPauta9(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
                      if (this.disciplinas.length === 10) { this.comporHtmlPauta10(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
                        if (this.disciplinas.length === 11) { this.comporHtmlPauta11(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
                          if (this.disciplinas.length === 12) { this.comporHtmlPauta12(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
                            if (this.disciplinas.length === 13) { this.comporHtmlPauta13(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
                              if (this.disciplinas.length >= 14) { this.comporHtmlPauta14(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) } else
                                if (this.disciplinas.length === 15) { this.comporHtmlPauta15(this.disciplinas, this.FiltroOpcoesImpressao(this.notas)) }
                                
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
        this.isLoading = true
      }
    },


    async save() {
      try {
        var params = {
          idCurso: this.editedItem.idCurso.idCurso,
          idAno_Academico: this.idclasse,
          descricao: this.$refs.myid.innerText,
          autor: '',
          periodo: this.editedItem.periodo.descricao
        }
      } catch (error) {

      }

      let turmajaexiste = this.turmas.filter(
        t => t.turmadescricao === this.$refs.myid.innerText
      )

      if (!turmajaexiste.length > 0) {
        try {
          let msg = await axios
            .post('/turmaInsertOne', params)
            .then(res => res.data)
          // this.text = msg[1].insertId
          this.text = msg
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 2000
          })

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
            }
          } catch (error) { }
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) { }
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) { }
        } catch (error) {
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
        }
        let d = new Date()
        d = new Date(d.getTime() - 3000000)
        // eslint-disable-next-line camelcase
        let date_format_str = d.getFullYear().toString() + '-' + ((d.getMonth() + 1).toString().length === 2 ? (d.getMonth() + 1).toString() : '0' + (d.getMonth() + 1).toString()) + '-' + (d.getDate().toString().length === 2 ? d.getDate().toString() : '0' + d.getDate().toString()) + ' ' + (d.getHours().toString().length === 2 ? d.getHours().toString() : '0' + d.getHours().toString()) + ':' + ((parseInt(d.getMinutes() / 5) * 5).toString().length === 2 ? (parseInt(d.getMinutes() / 5) * 5).toString() : '0' + (parseInt(d.getMinutes() / 5) * 5).toString()) + ':00'
        let v = {
          turmadescricao: this.$refs.myid.innerText,
          periodo: this.editedItem.periodo.descricao,
          curso: this.editedItem.idCurso.descricao,
          data_2: date_format_str
        }

        this.turmas.unshift(v)
        this.close()
      } else {
        this.$store.dispatch('textMessage', {
          msg: 'A turma já existe',
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }
  }
}
</script>
